import { Day, endOfWeek, startOfWeek } from 'date-fns';
import formatDateToUtcFormat from 'helpers/formatDateToUtcFormat';

export default function getFilterDates({
  startWeekDay,
  currentDate,
}: {
  startWeekDay: number;
  currentDate: Date;
}) {
  const startOfWeekDay = startOfWeek(currentDate, {
    weekStartsOn: startWeekDay as Day,
  });
  const endOfWeekDay = endOfWeek(currentDate, {
    weekStartsOn: startWeekDay as Day,
  });

  const dateAfter = formatDateToUtcFormat(startOfWeekDay);
  const dateBefore = formatDateToUtcFormat(endOfWeekDay);

  return { dateBefore, dateAfter, currentDate, startOfWeekDay, endOfWeekDay };
}
